/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Route } from 'react-router-dom';

const CreateRouteWithSubRoutes = route => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Route path={route.path} render={props => <route.component {...props} routes={route.routes} />} />
);

export default CreateRouteWithSubRoutes;
